class SecureShield {
    constructor() {
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.addCustomDomainBlockingFormValidation();
    }
    initTagifyAddCustomDomainBlocking(){
        const emailInput = document.querySelector('#frm-addCustomDomainBlockingForm-addCustomDomainBlockingForm input[name=hostname]');
        const numberOfTagsEl = document.querySelector('#frm-addCustomDomainBlockingForm-addCustomDomainBlockingForm .number-of-added-domains');
        if(emailInput){
            let tg = new Tagify(emailInput, {
                pattern: /^(\*.)*[-A-Za-z0-9]+(?:\.[-A-Za-z0-9]+){1,14}$/,
                keepInvalidTags: false,
                backspace: "edit",
                editTags: 1,
                delimiters: ",|;| ,| |:|[\\\r]",
                maxTags: 5000,
            }).on('add', function () {
                let numberOfTags = parseInt(numberOfTagsEl.textContent) + 1;
                if(numberOfTags === 5000){
                    numberOfTagsEl.parentElement.classList.add('badge-light-danger');
                    numberOfTagsEl.parentElement.classList.remove('badge-light-primary');
                    numberOfTagsEl.classList.add('text-danger');
                    numberOfTagsEl.classList.remove('text-primary');
                }
                numberOfTagsEl.textContent = numberOfTags;
            }).on('remove', function(){
                let numberOfTags = parseInt(numberOfTagsEl.textContent) - 1;
                if(numberOfTags < 5000){
                    numberOfTagsEl.parentElement.classList.remove('badge-light-danger');
                    numberOfTagsEl.parentElement.classList.add('badge-light-primary');
                    numberOfTagsEl.classList.remove('text-danger');
                    numberOfTagsEl.classList.add('text-primary');
                }
                numberOfTagsEl.textContent = numberOfTags;
            });
            new SpacebarEvent(tg);
        }
    }
    addCustomDomainBlockingFormValidation(){
        let form = document.getElementById('frm-addCustomDomainBlockingForm-addCustomDomainBlockingForm');
        if(form){
            this.exportCsv();
            if(form.querySelector('input[name=hostname]')){
                this.initTagifyAddCustomDomainBlocking();
            }
            let submitButton = document.getElementById('add_custom_domain_blocking_form_submit');

            let validator = FormValidation.formValidation(
                form,
                {
                    fields: {
                        'hostname': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                            },
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger(),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        // defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        }),
                    }
                }
            );

            submitButton.addEventListener('click', function (e) {
                // Prevent default button action
                e.preventDefault();
                validator.validate().then(function(status) {
                    if(status === 'Valid'){
                        new DismissModal('add_custom_domain_blocking_modal').disable();
                        // Show loading indication
                        submitButton.setAttribute('data-kt-indicator', 'on');
                        // Disable button to avoid multiple click
                        submitButton.disabled = true;
                        $('#frm-addCustomDomainBlockingForm-addCustomDomainBlockingForm').submit();
                    }
                });
            });

            $.nette.ext('addCustomDomainBlockingForm', {
                success: function (payload, status, jqXHR, settings) {
                    let formID = settings.nette.form[0].attributes.id.value;
                    if(formID === 'frm-addCustomDomainBlockingForm-addCustomDomainBlockingForm'){
                        if(payload){
                            toastr.success('Domain has been successfully created!');
                        } else {
                            toastr.error('This domain has been already created or you have exceeded the limit!');
                        }

                        let form = $('#frm-addCustomDomainBlockingForm-addCustomDomainBlockingForm');
                        new DismissModal('add_custom_domain_blocking_modal').enable();
                        bootstrap.Modal.getInstance(document.getElementById('add_custom_domain_blocking_modal')).hide();

                        $('#custom-domain-blocking-datatable').DataTable().draw();

                        form.find('input[name=hostname]').val('');
                        form.find('input[name=includeAllSubdomains]').prop('checked', true);

                        // Cancel loading indication
                        submitButton.setAttribute('data-kt-indicator', 'off');
                        submitButton.disabled = false;

                        // Set Save Changes button active
                        let saveChangesBtn = document.getElementById('saveChangesBtn');
                        if(saveChangesBtn){
                            saveChangesBtn.disabled = false;
                            let pulseBtn = document.getElementById('saveChangesPulse');
                            if(!pulseBtn){
                                let pulseBtn = document.createElement("span");
                                pulseBtn.classList.add('pulse-ring', 'top-0', 'start-0', 'w-100', 'h-100');
                                pulseBtn.id = 'saveChangesPulse';
                                saveChangesBtn.appendChild(pulseBtn);
                            }
                        }
                        new LeavePageDialog(true);
                    }
                }
            });
        }
    }
    exportCsv(){
        let thisClass = this;
        $(document).on('click','#domain_blocking_tab button[data-kt-docs-table-export=true]',function(){
            new bootstrap.Modal(document.getElementById('loading-modal')).show();

            $.ajax({
                url: "/threat-blocker-and-dns/custom-domain-blocking-csv-export?organizationID="+thisClass.organizationID,
                method: 'GET',
                xhrFields: {
                    responseType: 'blob'
                },
                success: function (data) {
                    const a = document.createElement('a');
                    const url = window.URL.createObjectURL(data);
                    a.href = url;
                    a.download = 'custom-domain-blocking.csv';
                    document.body.append(a);
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                    setTimeout(function() {
                        bootstrap.Modal.getInstance(document.getElementById('loading-modal')).hide();
                        toastr.success('Custom Domain Blocking has been successfully downloaded!')
                    }, 50);
                },
                error: function (request, status, error) {
                    bootstrap.Modal.getInstance(document.getElementById('loading-modal')).hide();
                    toastr.error('Unexpected error occurred. Please try it again later or contact our support team.')
                }
            });
        });
    }
}
window.SecureShield = SecureShield;